import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  useExaminationsActions,
  useAlerts,
  FILE_ID,
  FILE_URL,
  FILE_URL_EXPIRES,
  BUCKET,
  MIMETYPE,
  NAME,
  ORIGINAL_NAME,
} from 'store/examinations';
import Spinner from 'components/FullScreenSpinner';

import Pdf from './Pdf';
import { Container, Image, DragBox } from './styles';

const Preview = ({ data, setImageUrl, parentRef, dragBoxRef, dragBoxStyle }) => {
  const { loadFile } = useExaminationsActions();
  const { action, loading, success } = useAlerts(loadFile);
  const fileUrl = success || data[FILE_URL];
  const isLoading = !data[FILE_ID] || !fileUrl || loading;

  const onClick = useCallback(() => {
    if (data[MIMETYPE] === 'application/pdf') {
      window.open(fileUrl, '_blank');
    } else {
      setImageUrl(data[FILE_ID]);
    }
  }, [data, fileUrl, setImageUrl]);

  useEffect(() => {
    action(data);
  }, [action, data]);

  return (
    <>
      <Container ref={parentRef} type="button" onClick={onClick} disabled={isLoading}>
        {(isLoading && <Spinner size={40} />) || (data[MIMETYPE] === 'application/pdf' && <Pdf url={fileUrl} />) || (
          <Image src={fileUrl} alt={data[NAME]} />
        )}
      </Container>
      <DragBox ref={dragBoxRef} style={dragBoxStyle} $src={fileUrl} />
    </>
  );
};

Preview.propTypes = {
  data: PropTypes.shape({
    [FILE_ID]: PropTypes.string.isRequired,
    [FILE_URL]: PropTypes.string,
    [FILE_URL_EXPIRES]: PropTypes.string,
    [BUCKET]: PropTypes.string.isRequired,
    [MIMETYPE]: PropTypes.string.isRequired,
    [NAME]: PropTypes.string.isRequired,
    [ORIGINAL_NAME]: PropTypes.string.isRequired,
  }).isRequired,
  setImageUrl: PropTypes.func.isRequired,
  parentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]).isRequired,
  dragBoxRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]).isRequired,
  dragBoxStyle: PropTypes.shape({}).isRequired,
};

export default Preview;
